var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.977539 3.26355C0.977539 1.51184 2.39758 0.0917969 4.14928 0.0917969H33.9637C35.7154 0.0917969 37.1354 1.51184 37.1354 3.26354V33.0779C37.1354 34.8296 35.7154 36.2497 33.9637 36.2497H4.14929C2.39758 36.2497 0.977539 34.8297 0.977539 33.0779V3.26355Z",
    fill: "url(#paint0_linear_427_20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5232 18.1707C29.5232 24.3017 24.5531 29.2719 18.4221 29.2719C12.2912 29.2719 7.32103 24.3017 7.32103 18.1707C7.32103 12.0398 12.2912 7.06964 18.4221 7.06964C24.5531 7.06964 29.5232 12.0398 29.5232 18.1707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.788 13.7078C24.3955 13.3148 23.758 13.315 23.365 13.7078L16.9604 20.1126L14.1139 17.2661C13.7208 16.8731 13.0837 16.8731 12.6906 17.2661C12.2976 17.6592 12.2976 18.2963 12.6906 18.6894L16.2486 22.2474C16.4451 22.4438 16.7026 22.5423 16.9602 22.5423C17.2177 22.5423 17.4755 22.4441 17.6719 22.2474L24.788 15.1311C25.1811 14.7383 25.1811 14.1009 24.788 13.7078Z",
    fill: "url(#paint1_linear_427_20)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_20",
    x1: 12.396,
    y1: 17.9777,
    x2: 25.083,
    y2: 17.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_20",
    x1: 12.396,
    y1: 17.9777,
    x2: 25.083,
    y2: 17.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18AA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.dfe4c9dd1710f3e13ca4aa86f8adb538.svg";
export { ForwardRef as ReactComponent };